import { Button, Link, styled, TextField, Typography } from "@mui/material";
import { FC } from "react";
import { useForm } from "react-hook-form";
import { LogoServiestate } from "../atoms/logo-serviestate";

export interface LoginFormData {
  email: string;
  password: string;
}

export type LoginBoxProps = {
  onSubmit: (data: LoginFormData) => void;
  loading: boolean;
};

export const LoginBox: FC<LoginBoxProps> = ({ onSubmit, loading }) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm<LoginFormData>();

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)} className="box-container">
        <div className="logo-container">
          <LogoServiestate />
        </div>
        <TextField
          disabled={loading}
          label="Correo electrónico"
          fullWidth
          error={!!errors.email}
          helperText={errors.email?.message}
          {...register("email", {
            required: "El correo electrónico es requerido",
            pattern: {
              value:
                /^[\w!#$%&'*+/=?`{|}~^-]+(?:\.[\w!#$%&'*+/=?`{|}~^-]+)*@(?:[A-Z0-9-]+\.)+[A-Z]{2,6}$/gi,
              message:
                "El correo electrónico introducido no tiene un formato válido",
            },
          })}
        />
        <TextField
          type="password"
          disabled={loading}
          label="Contraseña"
          fullWidth
          error={!!errors.password}
          helperText={errors.password?.message}
          {...register("password", {
            required: "La contraseña es requerida",
          })}
        />
        <Button
          type="submit"
          variant="contained"
          size="large"
          disabled={loading}
        >
          Identificarse
        </Button>
        <Typography align="center">
          <Link target="_blank" href="https://www.serviestate.com/es/registro/">
            Registrarse
          </Link>
          &nbsp;o&nbsp;
          <Link href="/recovery-password">Recuperar contraseña</Link>
        </Typography>
      </form>
    </Container>
  );
};

const Container = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  padding: theme.spacing(5),

  ".box-container": {
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
    maxWidth: "400px",

    "> button": {
      marginTop: "1rem",
    },
  },
}));
